<div class="shop-container">
  <app-shop-purchase-popup
    *ngIf="showSuccessPopup"
    [inputs]="popupData"
  ></app-shop-purchase-popup>

  <div class="shop-header">
    <div class="back-button" (click)="back()">
      <img class="icon-shadow" src="assets/shop/angle-down.svg" />
    </div>
    <span>فروشگاه</span>
    <div class="dividar"></div>
    <div class="discount-button" (click)="showDiscountDialog()">
      <img src="assets/shop/discount.svg" class="discount-button-image" />
    </div>
  </div>

  <div>
    <div class="account-status">
      <img src="assets/shop/check.svg" *ngIf="display" alt="" />
      <p class="current-status-title">وضعیت اشتراک شما:</p>
      <p class="current-plan" *ngIf="!display">بدون اشتراک!</p>
      <p class="current-plan" *ngIf="display">
        {{ remainingSubscription }} روز باقی مانده
      </p>
    </div>
    <swiper
      class="slider-wrapper"
      [centeredSlides]="true"
      [slidesPerView]="'auto'"
      [spaceBetween]="24"
      (swiper)="onSwiper($event)"
      (slideChange)="onSlideChange($event)"
      dir="rtl"
      (click)="purchase(activeSlide)"
      #slider
    >
      <ng-template
        class="shop-cart"
        swiperSlide
        *ngFor="let price of prices; let i = index"
      >
        <div [ngClass]="{ promotion: price.promotion }">
          <p class="shop-cart-title">
            {{ price.title }}
          </p>
          <p class="hint" *ngIf="!price.promotion">
            {{
              price.profitAmount == 0
                ? 'صفر '
                : price.profitAmount.toLocaleString()
            }}
            ‌تومان سود
          </p>
          <p class="promotion-title" *ngIf="price.promotion">
            {{ price.promotion.title }}
          </p>
          <p class="promotion-reming" *ngIf="price.promotion">
            {{ price.promotion.expireStatus }}
          </p>
          <p
            *ngIf="planHasDiscount(price._id) && discountCode"
            class="before-discount-price"
          >
            {{ price.rawMonthlyPrice }} هزار تومان
          </p>
          <div class="monthlyprice">
            <p *ngIf="!planHasDiscount(price._id)">
              {{ price.rawMonthlyPrice.toLocaleString() }}
            </p>
            <p *ngIf="planHasDiscount(price._id)">
              {{ price.discountedMonthlyPrice.toLocaleString() }}
            </p>
            <div class="detail">
              <p class="unit">تومان</p>
              <p class="month">به‌ازای هر ماه</p>
            </div>
          </div>

          <div
            class="off"
            [ngClass]="{
              'bg-shadow': planHasDiscount(price._id) || price.promotion
            }"
          >
            <p *ngIf="!planHasDiscount(price._id) && !price.promotion">
              بدون تخفیف
            </p>
            <img
              *ngIf="planHasDiscount(price._id) || price.promotion"
              [src]="price.icon ? price.icon : 'assets/shop/gift.png'"
              alt=""
            />
            <div *ngIf="planHasDiscount(price._id)">
              <p class="percent">{{ price.discountPercent }}%</p>

              <p
                class="off-text"
                *ngIf="planHasDiscount(price._id) || price.promotion"
              >
                تخفیف
              </p>
            </div>
          </div>
        </div>
      </ng-template>
    </swiper>
    <div
      class="bullets-wrapper"
      [ngStyle]="{ 'flex-direction': 'row-reverse' && slide }"
      *ngIf="prices"
    >
      <span
        *ngFor="let in of counter(prices.length); let i = index"
        class="bullets"
        [ngClass]="{ active: activeSlide == i }"
      ></span>
    </div>
    <div class="shop-detail">
      <p class="shop-detail-title">چرا باید اشتراک بخریم؟</p>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>برنامه غذایی متناسب با سلیقه و مشخصات فردی</p>
      </div>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>امکان دریافت برنامه غذایی گیاه‌خواری</p>
      </div>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>رژیم‌های خاص مانند کتوژنیک، مدیترانه‌ای، آلکالاین و ...</p>
      </div>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>برنامه مخصوص دوران بارداری و شیردهی</p>
      </div>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>امکان حذف غذاهای مضر برای بیماری‌‌های مختلف</p>
      </div>
      <div class="shop-detail-item">
        <img src="assets/shop/check.svg" alt="" />
        <p>قابلیت اجرای انواع فستینگ مانند ۱۶:۸، ۵:۲ و ...</p>
      </div>
    </div>
  </div>
  <div
    class="purches"
    *ngIf="prices && activeSlide >= 0"
    (click)="purchase(activeSlide)"
  >
    <div class="title">
      <img src="assets/shop/forward.svg" alt="" />
      <p>پرداخت کن</p>
    </div>
    <div class="total">
      <span>مجموع:</span>
      <p>
        {{ getTotalPrice() }}
      </p>
      <span>تومان</span>
    </div>
  </div>
</div>
<app-cooking-story-success-message></app-cooking-story-success-message>
